// Copyright 2019, White Label Communications, LLC, All rights reserved.

// import fetch from 'cross-fetch';

export const FETCH_MESSAGE_RETENTION_START = 'FETCH_MESSAGE_RETENTION_START';
function fetchMessageRetentionStart() {
  return {
    type: FETCH_MESSAGE_RETENTION_START,
  };
}

export const FETCH_MESSAGE_RETENTION_SUCCESS = 'FETCH_MESSAGE_RETENTION_SUCCESS';
function fetchMessageRetentionSuccess(json) {
  return {
    type: FETCH_MESSAGE_RETENTION_SUCCESS,
    data: json,
  };
}

export const FETCH_MESSAGE_RETENTION_ERROR = 'FETCH_MESSAGE_RETENTION_ERROR';
function fetchMessageRetentionError(json) {
  return {
    type: FETCH_MESSAGE_RETENTION_ERROR,
    error: json.message,
  };
}

export function fetchMessageRetention(teamId) {
  return async (dispatch) => {
    const jsonResponse = true;
    dispatch(fetchMessageRetentionStart());
    const fetchobj = {
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };
    const url = `${process.env.REACT_APP_API_URL}/api/v4/admin/teams/${teamId}/message_retention`;
    await fetch(
      url,
      fetchobj,
    )
      .then((response) => (response.json()))
      .then((responseJson) => {
        if (responseJson.status_code && responseJson.status_code !== 200) {
          dispatch(fetchMessageRetentionError(responseJson));
        } else {
          dispatch(fetchMessageRetentionSuccess(responseJson));
        }
      })
      .catch((error) => {
        console.log(error, ': error'); // eslint-disable-line no-console
        if (error.message) {
          dispatch(fetchMessageRetentionError(error));
        } else {
          dispatch(fetchMessageRetentionError({ message: 'API error' }));
        }
      });

    return { data: jsonResponse };
  };
}

export const MESSAGE_RETENTION_POST_START = 'MESSAGE_RETENTION_POST_START';
function messageRetentionPostStart() {
  return {
    type: MESSAGE_RETENTION_POST_START,
  };
}

export const MESSAGE_RETENTION_POST_SUCCESS = 'MESSAGE_RETENTION_POST_SUCCESS';
function messageRetentionPostSuccess(response) {
  return {
    type: MESSAGE_RETENTION_POST_SUCCESS,
    data: response,
    timestamp: Date.now(),
  };
}

export const MESSAGE_RETENTION_POST_ERROR = 'MESSAGE_RETENTION_POST_ERROR';
function messageRetentionPostError(error) {
  const ret = {
    type: MESSAGE_RETENTION_POST_ERROR,
    error: error.message,
  };
  return ret;
}

export function postMessageRetention(formData, teamId) {
  return async (dispatch) => {
    const jsonResponse = true;
    dispatch(messageRetentionPostStart());
    // console.log('messageRetention2: ', formData); // eslint-disable-line no-console
    const fetchobj = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
      credentials: 'include',
    };
    const url = `${process.env.REACT_APP_API_URL}/api/v4/admin/teams/${teamId}/message_retention`;
    await fetch(
      url,
      fetchobj,
    )
      .then((response) => (response.json()))
      .then((responseJson) => {
        if (responseJson.status_code && responseJson.status_code !== 200) {
          dispatch(messageRetentionPostError(responseJson));
        } else {
          dispatch(messageRetentionPostSuccess(responseJson));
        }
      })
      .catch((error) => {
        if (error.message) {
          dispatch(messageRetentionPostError(error));
        } else {
          dispatch(messageRetentionPostError({ message: 'API error' }));
        }
      });
    dispatch(messageRetentionPostSuccess(formData));
    return { data: jsonResponse };
  };
}
